import queryString from 'query-string'

import { useGlobalStaticStateContext } from './useGlobalStaticState'

export enum NMapSchemePrefix {
  IN_APP = 'inapp://',
  N_MAP = 'nmap://',
}

type NMapScheme =
  | NMapMyPlace
  | NMapCommon
  | NMapBookmark
  | NMapPlaceDetail
  | NMapDrivingAnalysis
  | NMapDrivingHistory
  | NMapAddressDetail

const useNMapScheme = () => {
  const { isFromMapsApp } = useGlobalStaticStateContext()

  const getNMapURLScheme = ({ path, query, prefix = NMapSchemePrefix.IN_APP }: NMapScheme) => {
    if (isFromMapsApp) {
      const mapsQueryString = query ? `?${queryString.stringify(query)}` : ''
      return `${prefix}${path}${mapsQueryString}`
    }

    // return `${NMapSchemePrefix[os]}${N_MAP_PATH[type]}${getQueryWithAppName(type)}${N_MAP_SCHEME_DEFAULT_PARAMS[os]}`
    return '' // TO-DO 사용할 때 추가
  }

  return { getNMapURLScheme }
}

export default useNMapScheme

interface NMapMyPlaceCheckInQuery {
  type: 'receipt' | 'checkin_search' | 'checkin_gallery'
  placeContext?: string
}

interface NMapMyPlaceReviewEditQuery {
  type: 'review'
  reviewId: string
  placeContext?: string
}

interface NMapMyPlaceReviewNewQuery {
  type: 'review'
  visitId: string
  placeContext?: string
}

/**
 * {@link https://oss.navercorp.com/place/local/issues/12304}
 */
interface NMapMyPlace {
  path: 'myplace'
  query: NMapMyPlaceCheckInQuery | NMapMyPlaceReviewEditQuery | NMapMyPlaceReviewNewQuery
  prefix?: NMapSchemePrefix
}

/**
 * {@link https://wiki.navercorp.com/pages/viewpage.action?pageId=460325086}
 */
interface NMapCommon {
  path: 'map' | 'button_back'
  query?: null
  prefix?: NMapSchemePrefix
}

export enum MapAppTabState {
  FULL = 'full',
  HALF = 'half',
}

interface NMapBookmarkQuery {
  tab: 'bookmark'
  tabstate?: MapAppTabState
}

interface NMapBookmark {
  path: 'bookmark'
  query: NMapBookmarkQuery
  prefix: NMapSchemePrefix.N_MAP
}

interface NMapPlaceDetailQuery {
  id: string
  mode?: string
}

interface NMapDrivingAnalysis {
  path: 'driving_analysis'
  prefix: NMapSchemePrefix.N_MAP
  query: {
    focusInsurance: boolean
  }
}

interface NMapDrivingHistory {
  path: 'driving_history'
  prefix: NMapSchemePrefix.N_MAP
  query: null
}

interface NMapPlaceDetail {
  path: 'place'
  query: NMapPlaceDetailQuery
  prefix: NMapSchemePrefix.IN_APP | NMapSchemePrefix.N_MAP
}

interface NMapAddressDetail {
  path: 'place'
  query: {
    name: string
    lat: number
    lng: number
    mode: 'summary'
  }
  prefix: NMapSchemePrefix.N_MAP
}
